import { render, staticRenderFns } from "./DesignCalendar.vue?vue&type=template&id=46a8c4dc&scoped=true"
import script from "./DesignCalendar.vue?vue&type=script&lang=js"
export * from "./DesignCalendar.vue?vue&type=script&lang=js"
import style0 from "./DesignCalendar.vue?vue&type=style&index=0&id=46a8c4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a8c4dc",
  null
  
)

export default component.exports